/**
 * Ghost Constants
 *
 * Single Source of Truth for ghost dimensions in frontend/core.
 * NOTE: These values MUST match ghost-model.ts in BlockSuite.
 */

import { parseXYWH } from '@blocksuite/global/gfx';

/** Default ghost width - must match ghost-model.ts DEFAULT_GHOST_WIDTH */
export const GHOST_WIDTH = 200;

/** Default ghost height - must match ghost-model.ts DEFAULT_GHOST_HEIGHT */
export const GHOST_HEIGHT = 100;

/** Gap between ghost and source element */
export const GHOST_GAP = 100;

/** Vertical offset for stacking multiple ghosts */
export const GHOST_STACK_OFFSET = 120;

// =============================================================================
// Position Utilities
// =============================================================================

export type OriginalPosition = {
  x: number;
  y: number;
  w: number;
  h: number;
};

/**
 * Parses an xywh string to an OriginalPosition object.
 * Delegates to the central GFX xywh parser.
 *
 * @param xywh - JSON string like "[x, y, w, h]"
 * @returns OriginalPosition or undefined if parsing fails
 */
export function parseXywhToPosition(
  xywh: string | undefined
): OriginalPosition | undefined {
  const parsed = parseXYWH(xywh);
  if (!parsed) return undefined;
  const [x, y, w, h] = parsed;
  return { x, y, w, h };
}
